/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateTagLangRequestViewModel } from "../types/CreateTagLangRequestViewModel.ts";

export const createTagLangRequestViewModelSchema = z.object({
  cultureInfo: z.string().nullish(),
  tagTitle: z.string().nullish(),
}) as unknown as ToZod<CreateTagLangRequestViewModel>;
